function resolve(root, path) {
  if (!root || !path) return null;
  return path.split('.').reduce((node, key) => (node ? node[key] : null), root);
}

export default {
  props: {
    form: {
      type: Object,
      required: true,
    },
    v: {
      type: Object,
      default: null,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    field(path) {
      return resolve(this.v, path);
    },
    err(path) {
      const node = this.field(path);
      return !!(node && node.$error);
    },
    touch(path) {
      const node = this.field(path);
      if (node && typeof node.$touch === 'function') node.$touch();
    },
    hint(path) {
      const node = this.field(path);
      if (!node || !node.$error) return '';
      if (node.required === false) return 'Campo obrigatório';
      if (node.date === false) return 'Data inválida';
      if (node.hour === false) return 'Hora inválida';
      if (node.minLength === false || node.maxLength === false) {
        const min = node.$params.minLength ? node.$params.minLength.min : null;
        const max = node.$params.maxLength ? node.$params.maxLength.max : null;
        return min && max ? `Entre ${min} e ${max} dígitos` : 'Tamanho inválido';
      }
      if (node.minDate === false) return 'Anterior à data do atendimento';
      if (node.maxDate === false) return 'Data posterior ao atendimento';
      return 'Valor inválido';
    },
    fieldId(path) {
      return `guide-field-${path.replace(/\./g, '-')}`;
    },
  },
};
